/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react'; // we need this to make JSX compile
import { Logger } from '../../../../libs/utils/logger';
import { SignUpIndividual } from './SignUpIndividual';
import { Grid } from '@mui/material';
import { HeaderSignup } from '../HeaderSignup';
import { CustomerType } from '../../../../types/common.interfaces';

/**
 * Component: Signup individual
 * Usage: User signup page
 */

Logger.debug("SignUpIndividualWrapper.tsx", "SignUpIndividualWrapper initializing")

export const SignUpIndividualWrapper: React.FC<any> = React.memo(() => {
         const source = {
        url: "/",
        method: "GET",
        data: {}
      } 
     return (
       <Grid item container xs={12}>
         <HeaderSignup percentage={57} logoutIconRequired={true} customerType={CustomerType.JOINT_TENANCY}/>
         <div className='signup-individual-container'>
           <SignUpIndividual source={source} id={"individual-user-signup"} />
         </div>
       </Grid>
     );

});
